import { cn } from "../../utils";

export const AppNavSection = ({ className, ...props }: React.ComponentProps<"div">) => (
  <div className={cn("overflow-y-auto p-1 space-y-px", className)} {...props} />
);
